export const loggedInStatus = () => {
    return localStorage.getItem('auth_token');
};

export const invalidateSession = () => {
    return localStorage.removeItem('auth_token');
};

export const parseToken = (token) => {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
    );

    return JSON.parse(jsonPayload);
};

/* ---- Age Checks ---- */

export const mustBe16 = (token) => {
    let output = parseToken(token);
    //The user must be older than 16 or turn 16 the same year to register for a account.
    return new Date().getFullYear() - output.CivicNumber.slice(0, 4) >= 16;
};

export const isOver55 = (token) => {
    let output = parseToken(token);
    //The user must be older than 16 or turn 16 the same year to register for a account.
    return new Date().getFullYear() - output.CivicNumber.slice(0, 4) >= 55;
};

export const createDateFormatter = (locale = 'sv-SE') =>
    new Intl.DateTimeFormat(locale);
